import React from 'react';
import { Capacitor } from '@capacitor/core';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Chat from './pages/Chat';
import Admin from './pages/Admin';
import Landing from './pages/Landing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import './App.css';

function ProtectedRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', background: '#1a1416' }} />;
  if (!currentUser) return <Navigate to="/login" />;
  return children;
}

function EntryRoute() {
  const { currentUser, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', background: '#1a1416' }} />;
  return <Navigate to={currentUser ? "/chat" : "/login"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={Capacitor.isNativePlatform() ? <EntryRoute /> : <Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/chat" element={
            <ProtectedRoute><Chat /></ProtectedRoute>
          } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
